// DelegatedRoute — a page the user reaches through an ACTIVE delegation of
// `capability` (DEF-0mvpyq10d005, NA-3: Grace covering David's leave
// approvals). Waits for auth's answer instead of bouncing to the dashboard on
// the first render; no delegation → the dashboard, as before.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { DataState } from '@/features/shared/components/ui/DataState';
import { useDelegatedCapabilities } from './useDelegatedCapabilities';

export const DelegatedRoute: React.FC<{ capability: string; children: React.ReactNode }> = ({ capability, children }) => {
  const { capabilities, ready } = useDelegatedCapabilities();
  if (!ready) return <DataState variant="loading" message="Checking what you're covering…" />;
  if (!capabilities.includes(capability)) return <Navigate to=".." replace />;
  return <>{children}</>;
};

export default DelegatedRoute;
